import dayjs from 'dayjs'
import { DashboardQuery } from '../orders/models/dashboard-stats.type'

// Stable palette shared across all dashboard charts.
export const CHART_COLORS = [
    '#1f77b4',
    '#ff7f0e',
    '#2ca02c',
    '#d62728',
    '#9467bd',
    '#8c564b',
    '#e377c2',
    '#17becf',
]

const integerFormatter = Intl.NumberFormat('no-NO', { maximumFractionDigits: 0 })
const currencyFormatter = Intl.NumberFormat('no-NO', {
    style: 'currency',
    currency: 'NOK',
    maximumFractionDigits: 0,
})

export const formatInt = (value: number): string => integerFormatter.format(value ?? 0)
export const formatCurrency = (value: number): string => currencyFormatter.format(value ?? 0)

// "2025-01" -> "jan. 2025"
export const formatMonthLabel = (label: string): string => {
    const parsed = dayjs(`${label}-01`)
    return parsed.isValid() ? parsed.format('MMM YYYY') : label
}

export type RangeKey = 'last_month' | 'last_3_months' | 'current_year' | 'last_year' | 'last_2_years'

export const DEFAULT_RANGE: RangeKey = 'current_year'

// Maps a preset to an absolute [dateFrom, dateTo] window (ISO strings).
export const getRange = (key: RangeKey): DashboardQuery => {
    const now = dayjs()
    switch (key) {
        case 'last_month': {
            const prev = now.subtract(1, 'month')
            return { dateFrom: prev.startOf('month').toISOString(), dateTo: prev.endOf('month').toISOString() }
        }
        case 'last_3_months':
            return { dateFrom: now.subtract(3, 'month').startOf('day').toISOString(), dateTo: now.endOf('day').toISOString() }
        case 'last_year': {
            const prevYear = now.subtract(1, 'year')
            return { dateFrom: prevYear.startOf('year').toISOString(), dateTo: prevYear.endOf('year').toISOString() }
        }
        case 'last_2_years':
            return { dateFrom: now.subtract(2, 'year').startOf('month').toISOString(), dateTo: now.endOf('day').toISOString() }
        case 'current_year':
        default:
            return { dateFrom: now.startOf('year').toISOString(), dateTo: now.endOf('day').toISOString() }
    }
}
